import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_INSTANT_BOOKING_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalBody from '../ModalBody';
import ModalHeader from '../ModalHeader';
import ModalFooter from '../ModalFooter';
import Button from '../Button';

import AgeRange from './rules/AgeRange';
import BookingEarly from './rules/BookingEarly';
import CouplesNotAllowed from './rules/CouplesNotAllowed';
import MinStay from './rules/MinStay';
import Gender from './rules/Gender';

import styles from './InstantBookingModal.module.scss';

const RULES = [
  'ageRange',
  'gender',
  'couplesNotAllowed',
  'bookingTooEarly',
  'minStay'
];

const rulesCorrelation = {
  ageRange: props => <AgeRange {...props} />,
  bookingTooEarly: props => <BookingEarly {...props} />,
  minStay: props => <MinStay {...props} />,
  couplesNotAllowed: () => <CouplesNotAllowed />,
  gender: props => <Gender {...props} />
};

const InstantBookingModal = ({ rules }) => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_INSTANT_BOOKING_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      contentLabel="modal"
      onRequestClose={handleModalClose}
      size="big"
    >
      <ModalHeader
        className={styles['instant-modal__block instant-modal__text-title']}
        onRequestClose={handleModalClose}
        label={trans('property_show.instant_booking_modal.header')}
      />
      <ModalBody className={styles['instant-modal__block']}>
        <p
          className={
            styles['instant-modal__text-title instant-modal__text-block']
          }
        >
          {trans('property_show.instant_booking_modal.title')}
        </p>
        <p className={styles['instant-modal__text-block']}>
          {trans('property_show.instant_booking_modal.description.1')}
        </p>
        <p className={styles['instant-modal__text-block']}>
          {trans('property_show.instant_booking_modal.description.2')}
        </p>
        <ul className={styles['instant-modal__rules-list']}>
          {RULES.map(ruleType => {
            const rule = rules.find(r => r.type === ruleType) || {};
            const RuleComponent = rulesCorrelation[rule.type];

            return RuleComponent ? (
              <RuleComponent key={ruleType} {...rule.params} />
            ) : null;
          })}
        </ul>
        <p
          className={styles['instant-modal__text-block']}
          dangerouslySetInnerHTML={{
            __html: trans('property_show.instant_booking_modal.check_rules')
          }}
        />
        <p className={styles['instant-modal__text-block']}>
          {trans('property_show.instant_booking_modal.dont_worry')}
        </p>
      </ModalBody>
      <ModalFooter className={styles['instant-modal__block']}>
        <Button onClick={handleModalClose} size="big" color="interaction">
          {trans('property_show.instant_booking_modal.understood')}
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;
};

InstantBookingModal.propTypes = {
  rules: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        params: PropTypes.shape(),
        type: PropTypes.string
      })
    ),
    PropTypes.shape({
      params: PropTypes.shape(),
      type: PropTypes.string
    })
  ]).isRequired
};

export default InstantBookingModal;
